export default class Collection
{
    constructor(items = []) {
        this._items = items;
        
        this[Symbol.iterator] = function* () {
            yield* this._items;
        };
    }

    all() {
        return this._items;
    }

    pop() {
        return this._items.pop();
    }

    push(item) {
        return this._items.push(item);
    }

    shift() {
        return this._items.shift();
    }

    unshift(item) {
        return this._items.unshift(item);
    }

    empty() {
        this._items = [];
    }

    get(key) {
        return this._items[key];
    }

    has(key) {
        return this.get(key) ? true : false;
    }

    reverse() {
        return this._items.reverse();
    }

    each(callback) {
        return this._items.forEach(item => {
            callback(item);
        });
    }

    count() {
        return this._items.length;
    }
}